module.exports = __webpack_public_path__ + "static/img/uzaviraci_klapka.fdbe19e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uzaviraci_klapka.png
// module id = LY+b
// module chunks = 1